var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    display: "inline-block",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#32383E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.223,
    cy: 6.993,
    rx: 2.672,
    ry: 2.678
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.839,
    cy: 2.638,
    rx: 2.408,
    ry: 2.413
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.392,
    cy: 3.181,
    rx: 1.931,
    ry: 1.935
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.586,
    cy: 9.301,
    rx: 1.481,
    ry: 1.485
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.317,
    cy: 16.348,
    rx: 1.217,
    ry: 1.219
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.178,
    cy: 20.795,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.468,
    cy: 20.587,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.203,
    cy: 14.405,
    r: 1
  }))));
}
export default SvgLoader;